// extracted by mini-css-extract-plugin
export default {"scoreboard":"Scoreboard_scoreboard__rmk2U","logo":"Scoreboard_logo__-KElK","scores":"Scoreboard_scores__RcWK6","container":"Scoreboard_container__Aaba-"};